export default "__VITE_ASSET__BpGm4YVL__"